var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolhtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "45.655px",
    viewBox: "0 0 40 45.655",
    enableBackground: "new 0 0 40 45.655",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E34F26",
    d: "M3.335,40.934L-0.014,0l40,0.082l-3.541,40.852l-16.308,4.722L3.335,40.934z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF652A",
    d: "M20.138,41.702V3.898l16.472,0.055l-2.937,33.823L20.138,41.702z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.08,13.343l0.466-4.997H7.207l1.4,15.319h17.488l-0.686,6.534l-5.601,1.51l-5.683-1.647l-0.302-3.897 H8.799l0.687,7.96l10.323,2.884l10.405-2.884l1.4-15.538H13.247l-0.521-5.244H32.08z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolhtml);
export default __webpack_public_path__ + "static/media/toolhtml.feb99cbc7cc8e0b609e53e49688285ba.svg";
export { ForwardRef as ReactComponent };